export default "__VITE_ASSET__BYw9telU__"